import React from 'react'
import styled from 'styled-components'
import MagicHeader from 'components/magic/MagicHeader'
import {
  magicContainerStyle,
  titleStyle1,
  textStyle1,
} from 'components/magic/styled'
import GetStartedButton from 'components/magic/GetStartedButton'
import mediaQuery from 'styles/mediaQuery'

import ProductsList from '../ProductsList'

const Section = styled.section`
  position: relative;
  width: 100%;
  padding-bottom: 30px;
`

const Container = styled.div`
  ${magicContainerStyle};
  text-align: center;
`

const Title = styled.h1`
  ${titleStyle1};
`

const Text = styled.p`
  ${textStyle1};
`

const ButtonWrapper = styled.div`
  text-align: center;
  margin-bottom: 50px;

  ${mediaQuery.bigTabletMin} {
    margin-bottom: 110px;
  }
`

const ProductHeroSection = () => (
  <Section>
    <MagicHeader darkTheme />
    <Container>
      <Title>You make the best products, we take care of everything else</Title>
      <Text>
        Everything from sales reports to SKU-level analysis and all the way to
        ads, content, and forecast management, all this without the need to call
        your dev team ever.
      </Text>
      <ButtonWrapper>
        <GetStartedButton />
      </ButtonWrapper>
      <ProductsList />
    </Container>
  </Section>
)

export default ProductHeroSection
